import { useParams } from "react-router-dom";
import { useAuth } from "@/auth/auth";
import { BuildLogs } from "@/components/BuildLogs";

export function BuildsPage() {
  const { instanceId } = useParams<{ instanceId: string }>();
  const { organizationTid } = useAuth();
  return instanceId ? (
    <BuildLogs key={`${organizationTid}:${instanceId}`} instanceId={instanceId} />
  ) : null;
}
